import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FilterControl} from "../interface/filter-control";
import {FilterOption} from "../interface/filter-option";
import {ProductMetadataInfo} from "../interface/product-metadata-info";
import {FilterCsvMetadataService} from "../service/filter-csv-metadata.service";

@Component({
	selector: 'fb-filter-control',
	templateUrl: './filter-control.component.html',
	styleUrls: ['./filter-control.component.scss']
})
export class FilterControlComponent implements OnInit, OnChanges {

	@Output()
	public onControlChange: EventEmitter<null> = new EventEmitter<null>();

	@Input()
	public control: FilterControl = {} as FilterControl;
	public collapse: boolean = false;
	public fullView: boolean = false;
	public loading: boolean = false;
	public metadataList: ProductMetadataInfo[] = [];

	constructor(
		private _csvMetadata: FilterCsvMetadataService
	) {
	}

	ngOnInit(): void {
		if(this.control.key.key === 'color') {
			this.getColorList();
		} else if(this.control.key.key === 'pattern') {
			this.getPatternList();
		} else if(this.control.key.key === 'material') {
			this.getMaterialList();
		}
	}

	ngOnChanges(): void {
		if (this.control.key.key === 'color') {
			this.getColorList();
		} else if (this.control.key.key === 'pattern') {
			this.getPatternList();
		} else if (this.control.key.key === 'material') {
			this.getMaterialList();
		}
	}

	public onChange(): void {
		this.onControlChange.next(null);
	}

	public onMainChange(option: FilterOption): void {
		if(option.subOptions) {
			option.subOptions.forEach(subOpt => subOpt.active = option.active);
		}
		this.onChange();
	}

	public onSubChange(option: FilterOption): void {
		if (!option.subOptions) {
			return;
		}
		option.active = option.subOptions.every(subOption => subOption.active);
		this.onChange();
	}

	public toggleCollapse(): void {
		this.collapse = !this.collapse;
	}

	public getColorList(): void {
		if(FilterCsvMetadataService.colorList.length > 0) {
			this.metadataList = FilterCsvMetadataService.colorList
		}
		else {
			this._csvMetadata.getColorList(
				() => {
					this.loading = true;
				},
				() => {
					this.loading = false;
					this.metadataList = FilterCsvMetadataService.colorList;
				},
			);
		}
	}

	public getPatternList(): void {

		if(FilterCsvMetadataService.patternList.length > 0) {
			this.metadataList = FilterCsvMetadataService.patternList
		}
		else {
			this._csvMetadata.getPatternList(
				() => {
					this.loading = true;
				},
				() => {
					this.loading = false;
					this.metadataList = FilterCsvMetadataService.patternList;
				},
			);
		}
	}

	public getMaterialList(): void {

		if(FilterCsvMetadataService.materialList.length > 0) {
			this.metadataList = FilterCsvMetadataService.materialList
		}
		else {
			this._csvMetadata.getMaterialList(
				() => {
					this.loading = true;
				},
				() => {
					this.loading = false;
					this.metadataList = FilterCsvMetadataService.materialList;
				},
			);
		}

	}

	public getMetadataValue(option: FilterOption): string | undefined {
		return this.metadataList.find(m => m.id === +option.value)?.name;
	}

	public getColorHex(option: FilterOption): string | undefined {
		return this.metadataList.find(m => m.id === +option.value)?.hex;
	}

}
